var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M28.03 5.82v3.52H2V5.82C2 4.27 3.26 3 4.82 3h20.39c1.56 0 2.82 1.27 2.82 2.82z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.03 9.34v13.14c0 1.56-1.26 2.82-2.82 2.82H4.83C3.27 25.3 2 24.04 2 22.47V9.34z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m19.621 19.74 2.623 8.622c.254.835 1.43.853 1.709.025l1.228-3.644a.899.899 0 0 1 .564-.564l3.644-1.228c.827-.279.81-1.455-.025-1.709l-8.622-2.623a.899.899 0 0 0-1.121 1.121z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.66 24.401H4.83a1.932 1.932 0 0 1-1.93-1.93V10.24h24.23v6.941a.9.9 0 0 0 1.8 0V5.821a3.724 3.724 0 0 0-3.72-3.72H4.82a3.724 3.724 0 0 0-3.72 3.72v16.65a3.734 3.734 0 0 0 3.73 3.73h12.83a.9.9 0 0 0 0-1.8zM4.82 3.901h20.39c1.059 0 1.92.861 1.92 1.92V8.44H2.9V5.821c0-1.058.861-1.92 1.92-1.92z",
    fill: "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.99,
    cy: 6.164,
    r: 0.804,
    fill: "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.822,
    cy: 6.164,
    r: 0.804,
    fill: "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.654,
    cy: 6.164,
    r: 0.804,
    fill: "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.625 20.382-8.622-2.623a1.801 1.801 0 0 0-1.794.448 1.794 1.794 0 0 0-.449 1.795l2.623 8.623a1.769 1.769 0 0 0 1.693 1.273h.028a1.77 1.77 0 0 0 1.702-1.224l1.226-3.643 3.645-1.228a1.77 1.77 0 0 0 1.223-1.73 1.768 1.768 0 0 0-1.275-1.691zm-4.168 2.945a1.81 1.81 0 0 0-1.129 1.129l-1.223 3.645-2.621-8.618 8.618 2.617z",
    fill: "#000000",
    opacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.d7824a6ee3b13357146c9c6bbb6cc61e.svg";
export { ForwardRef as ReactComponent };